import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  SearchForTaskSubjects_searchWithMetadata_items_resource_Building as SearchForTaskSubjectsItemBuildingGenerated,
  SearchForTaskSubjects_searchWithMetadata_items as SearchForTaskSubjectsItemGenerated,
  SearchForTaskSubjects_searchWithMetadata_items_resource_Inquiry as SearchForTaskSubjectsItemInquiryGenerated,
  SearchForTaskSubjects_searchWithMetadata_items_resource_CufSpace as SearchForTaskSubjectsItemSpaceGenerated,
  SearchForTaskSubjects_searchWithMetadata_items_resource_Unit as SearchForTaskSubjectsItemUnitGenerated,
  SearchForTaskSubjects as SearchForTaskSubjectsResponseGenerated,
  SearchForTaskSubjectsVariables as SearchForTaskSubjectsVariablesGenerated,
} from "core/queries/__generated__/SearchForTaskSubjects";

export interface SearchForTaskSubjectsVariables
  extends SearchForTaskSubjectsVariablesGenerated {}
export interface SearchForTaskSubjectsResponse
  extends SearchForTaskSubjectsResponseGenerated {}
export interface SearchForTaskSubjectsItem
  extends SearchForTaskSubjectsItemGenerated {}

export interface SearchForTaskSubjectsItemBuilding
  extends SearchForTaskSubjectsItemBuildingGenerated {}

export interface SearchForTaskSubjectsItemSpace
  extends SearchForTaskSubjectsItemSpaceGenerated {}
export interface SearchForTaskSubjectsItemInquiry
  extends SearchForTaskSubjectsItemInquiryGenerated {}

export interface SearchForTaskSubjectsItemUnit
  extends SearchForTaskSubjectsItemUnitGenerated {}

export enum SearchForTaskSubjectsItemResourceType {
  Inquiry = "Inquiry",
  LeaseInquiry = "LeaseInquiry",
  Unit = "Unit",
}

const searchForTaskSubjects = gql`
  query SearchForTaskSubjects(
    $limit: Int = 25
    $filterInput: SearchFilterInput!
    $resultTypes: [Result!]!
    $searchTerm: String!
  ) {
    searchWithMetadata(
      filters: $filterInput
      pagination: { cursor: "0", limit: $limit }
      resultTypes: $resultTypes
      searchTerm: $searchTerm
    ) {
      items {
        id
        title
        subtitle
        resource {
          __typename
          ... on Building {
            buildingId: id
            name
            city {
              id
            }
            internalRef
            fullAddress
            liveUnitCount: totalUnitCount(live: true)
          }
          ... on City {
            cityId: id
          }
          ... on CufSpace {
            id
            building {
              id
              city {
                id
              }
            }
            internalRef
            type
          }
          ... on Inquiry {
            id
            checkInTime
            checkOutTime
            intrastayCleaningConfig {
              id
              availableTimes
            }
            unit {
              id
              city {
                id
              }
              shortInternalRef
            }
          }
          ... on LeaseInquiry {
            id
            checkInTime
            checkOutTime
            intrastayCleaningConfig {
              id
              availableTimes
            }
            unit {
              id
              city {
                id
              }
              shortInternalRef
            }
          }
          ... on TomBooking {
            id
            checkInTime
            checkOutTime
            unit {
              id
              city {
                id
              }
              shortInternalRef
            }
          }
          ... on User {
            id
          }
          ... on Unit {
            id
            aptNumberOrInternalRef
            city {
              id
            }
            images(limit: 0) {
              id
              url
            }
          }
          ... on Task {
            id
          }
          ... on TaskContext {
            id
          }
          ... on TaskTypeConfiguration {
            id
          }
          ... on TomBooking {
            id
          }
        }
      }
    }
  }
`;

export interface UseSearchForTaskSubjects {
  skip?: boolean;
  variables: SearchForTaskSubjectsVariables;
}

export const useSearchForTaskSubjects = ({
  skip = false,
  variables,
}: UseSearchForTaskSubjects) =>
  useQuery<SearchForTaskSubjectsResponse, SearchForTaskSubjectsVariables>(
    searchForTaskSubjects,
    {
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
      skip,
      variables,
    },
  );
